import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
 import './classes/ManageMyAthletes.css';
import { Helmet } from 'react-helmet';
import { useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import { GridFilterInputValue } from '@mui/x-data-grid';
import Loading from './Loading';
import AgentBackendSidebar from "./AgentBackendSidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const ManageMyAthletes =() =>{
  /* Pagination, filter config starts here */
  const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [deleteReason, setDeleteReason] = useState("");
  const[message,setMessage] = useState([]);
  const [userLoggedInId,setUserLoggedInId] = useState({});
  const domainName = window.location.host.replace(/^https?:\/\//, '');

  const loggedin_uid = localStorage.getItem('uid');
  const app_url = configData.APP_URL;
  const location  = useLocation();
 const successMessage = location.state?.message; // Access the message
 window.history.replaceState({}, '');

const fetchData = async () => {
  try {
    setIsLoading(true);
    const response = await fetch(app_url + 'smwwagency/myathlete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: paginationModel.page,
        pageSize: paginationModel.pageSize,
        sortModel,
        filterModel,
        uid: loggedin_uid,
      }),
    });

    const data = await response.json();
    console.log(data.data.rows);
    setRows(data.data.rows);
    setRowCount(data.data.totalRowCount);
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    fetchData();
  }, [paginationModel, sortModel, filterModel]);

  // Handle delete click -> open modal
  const handleDeleteClick = (athlete) => {
    console.log(athlete);
    setSelectedAthlete(athlete);
    setDeleteReason("");
    setShowModal(true);
  };

   const confirmDelete = async (athlete_uid,agent_uid) => {
    

    if (!deleteReason.trim()) {
      alert("Please provide a reason for dropping the athlete.");
      return;
    }

    const senddata = {
      athlete_uid: athlete_uid,
      agent_uid: agent_uid,
      reason: deleteReason,
    };

    try {
      const response = await fetch(app_url + "smwwagency/dropathlete", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(senddata),
      });

      const data = await response.json();

      if (data.data.result === "Success") {
        alert("Athlete successfully dropped.");
        setShowModal(false);
        fetchData(); //  Refresh the athlete list after deletion
      } else {
        alert("Failed to drop athlete. Please try again.");
      }
    } catch (error) {
      console.error("Error dropping athlete:", error);
    }
  };


const columns = [
  {
    field: 'name',
    headerName: 'Name',
    cellClassName:'name_column',headerClassName:'name_header',  
    flex:1,
    sortable: false,
    filterable: false,  
     renderCell: (params) => (
    <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.name}
      </Link>
  ),
    
  },
  {
    field: 'date_of_assignment',
    headerName: 'Date of Assignment',
    cellClassName:'date_of_assignment_column',headerClassName:'date_of_assignment_header',
    flex:1,
    sortable: false,
    filterable: false,
 },
 
  {
    field: 'actions',
    headerName: 'Actions',
    cellClassName:'actions_column',headerClassName:'actions_header',
    flex:1,
    sortable: false,
    filterable: false, 
    renderCell: (params) => (
        <>
      <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.linkText || 'View'}
      </Link> {"|"}
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer"   onClick={(e) => {
              e.preventDefault();
              handleDeleteClick(params.row);
            }} 
            style={{ color: "#2C99D2",cursor:"pointer"}}
            >
        {params.row.linkText || 'Delete'}
      </Link>
      </>
    ),
  },
  //{ field: 'athlete_uid', headerName: 'Athlete Uid', hide: true },
];

 useEffect(() => {
              Promise.all([
                  checkpermissionforpageaccess()
              ])
              .then(() => {
           
              setIsLoading(false);
              })
           
          },[]);
           async function checkpermissionforpageaccess() {
    
       
            const response = await fetch(
                 app_url+'smwwagency/checkpermissionforotherpageaccess?uid='+loggedin_uid,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                
            } 
             if(responsedata.data.msg === "Error") {
                setMessage(responsedata.data.result);
            } 

       
    }
 
    return(
      <>
               {isLoading ? (
                    <Loading />
                  ) : (
        <div id="main">
            <div className="left"></div>
            <>
                <div className="center left-center">
                  {message.length > 0 ? (
                <div>
                  {message.map((item, index) => {
                    return <><div dangerouslySetInnerHTML={{ __html: item }} /><br /></>
          
                  })}  
                </div>
              ) : (
                    <div className="manage-my-athletes-container">
                      <Helmet><title>My Athletes</title></Helmet>
                        {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        <h1>Manage My Athletes</h1>
                        <div className="manage-my-athletes-view-content">
                          <div style={{float:"right"}}>
                            <a href="/add_athlete">
                            <img src="/basic/web/images/add_new.png"/>Create Athlete</a>
                           </div>
                          <table className="manage-my-athletes-view-table">
                                  <div style={{ width: '100%' }}>
                                  <DataGrid
                                  rows={rows}
                                  columns={columns}
                                  rowCount={rowCount}
                                  paginationMode="server"
                                  sortingMode="server"
                                  filterMode="server"
                                  paginationModel={paginationModel}
                                  onPaginationModelChange={setPaginationModel}
                                  sortModel={sortModel}
                                  onSortModelChange={setSortModel}
                                  filterModel={filterModel}
                                  onFilterModelChange={setFilterModel}
                                  pageSizeOptions={[5, 10, 25,50]}
                                  getRowId={() => crypto.randomUUID()}
                                  getRowHeight={() => 'auto'}
                                  disableColumnFilter 
                                  sx={{
                                    '@media (min-width:1065px) and (max-width:1200px)': {
                                      '& .MuiDataGrid-virtualScroller': {
                                        width: '100% !important',
                                      },
                                    
                                    },
                                  }}
                                  // disableColumnResize={true}
                              />
                              </div>
                          </table>
                            
                        </div>

                    </div>
              )}
                </div>
        </>
        <div class="right">
            {/* <AgentSidebar/> */}
            <SalespersonSidebar />
                {/* {!isReady ? (
                  <></>
                ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                  userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                  <>
                    <AgentBackendSidebar />
                    <SalespersonSidebar />
                  </>
                ) : (domainName === configData.RSMWW_AGENCY_DOMAIN &&
                  userLoggedInRoles.includes(configData.ROLE_AGENT)) ? (
                  <AgentBackendSidebar />
                ) : (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                  userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                  userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)) ? (
                  <SalespersonSidebar />
                ) : (
                  <div>
                    <h1>Quick Links</h1>
                    <ul style={{padding: "0px"}}>
                        <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                        <a href="/smww_pay">
                        <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                        </a>
                        </li>        
                    </ul>
                  </div>
                )} */}
        </div>
        </div>
       )}
             {/* Drop Athlete Modal */}
      {showModal && (
        <div id="editModal" className="modal view-event-modal edit-modal-all">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Drop Athlete</h2>
              <span className="close" onClick={() => setShowModal(false)}>
                ×
              </span>
            </div>
            <div className="modal-body edit-model">
              <p>
                Please specify why you're dropping <b>{selectedAthlete?.name}</b>:
              </p>
              <div style={{ marginBottom: "10px" }}>
                <textarea
                  value={deleteReason}
                  onChange={(e) => setDeleteReason(e.target.value)}
                  style={{ width: "100%", marginTop: "5px", height: "100px" }}
                />
              </div>
              <div className="form-item">
                <button onClick={() => confirmDelete(selectedAthlete?.athlete_uid,localStorage.getItem('uid'))}>Drop Athlete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>  
    );
};

export default ManageMyAthletes;